module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iNDgwIiB3aWR0aD0iNjQwIiB2aWV3Qm94PSIwIDAgNjQwIDQ4MCI+CiAgPGcgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgIDxwYXRoIGZpbGw9IiNmZmYiIGQ9Ik0yMTIuODc1IDBoMjEzLjk1djQ4MGgtMjEzLjk1eiIvPgogICAgPHBhdGggZmlsbD0icmVkIiBkPSJNMCAwaDIxMi44NzV2NDgwSDB6TTQyNS4xNjMgMEg2NDB2NDgwSDQyNS4xNjJ6Ii8+CiAgPC9nPgo8L3N2Zz4K"


//////////////////
// WEBPACK FOOTER
// ./~/flag-icon-css/flags/4x3/pe.svg
// module id = ./node_modules/flag-icon-css/flags/4x3/pe.svg
// module chunks = 0